import React from 'react';
import { FormattedMessage } from 'react-intl';

import Img from 'components/presenters/Img/Img';
import MainLayout from 'components/presenters/layouts/main/MainLayout';
import NoContent from 'components/widgets/NoContent/NoContent';
import routes from 'routesPaths';

import GridUpdatingHook from '../components/GridUpdatingHook/GridUpdatingHook';
import { COMPONENT_NAME } from '../constants';

import { CollectionGridLogic } from './components/CollectionGridLogic/CollectionGridLogic';
import { useCollectionGrid } from './hooks/useCollectionGrid/useCollectionGrid';

import styles from './CollectionGrid.module.scss';

function CollectionGrid() {
  const {
    gridSettings,
    gridType,
    gridData,
    wrapperRef,
    providerLogo,
    notValidPageTitle,
    setForceUpdate,
  } = useCollectionGrid();

  const shouldShowNoContent = !gridSettings || !gridData;

  if (shouldShowNoContent) {
    return (
      <MainLayout>
        <NoContent title={notValidPageTitle} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <GridUpdatingHook setForceUpdate={setForceUpdate} path={routes.collectionGrid.path} />
      <div ref={wrapperRef} className={styles.wrapper}>
        {!!providerLogo && <Img alt='provider logo' className={styles.providerLogo} src={providerLogo} />}
        <FormattedMessage
          defaultMessage={gridSettings.title}
          id={`${COMPONENT_NAME}.title.${gridSettings.title}`}
          tagName='h3'
        />
        <CollectionGridLogic type={gridType} settings={gridSettings} gridData={gridData} />
      </div>
    </MainLayout>
  );
}

export default React.memo(CollectionGrid);
